const documentTypes = {
  IntitialEvaluation: 1,
  AdditionalEvaluation: 2,
  MinuteReferralEvaluationAt: 13,
  AmendmentDocument: 14,
  ContractDocument: 15,
  MinutaDiscussionSigned: 16,
  EvaluationReportSigned: 17,
  Minuta: 20,
  Otro: 21,
  ReferralServiceAT: 23,
  LocationRejectedDocument: 26,
  MinuteControversy: 28,
  MinutaResolucionControversia: 29,

  //Intervetions Plans
  PlanDeIntervencion: 83,
  PaquetePlanAnual: 84,
  PlanDeEnmienda: 85,
  ResumenResultadoDeServicios: 86,
  VisitCertification: 89,
  AdmissionNoteReport: -1,
  PlanDeIntervencionFirmado: 225,
  InformeAltaBajaSAEESR06: 100,
  InformedeLogrosDiciembre: 244,
  InformedeLogrosMayo: 245,
  InformedeLogrosJunio: 1626,

  //Billing Documents
  CseeCertification: 94,
  MixedServicesCertification: 221,
  ExcelMaster: 222,
  PaymentDistribution: 223,
  TapRequestCartaAprobacionFirmada: 208,

  //SPECPractitioner
  AgreementWithTheUniversity: 232,
  SupervisorCertification: 233,
  InvoiceAdjustment: 226,
};

export default documentTypes;
